export { FeedbackProvider_ModalsComponent } from './feedback-provider/feedback-provider.component';
